import { render } from "./OptionsListTab.vue?vue&type=template&id=72ca0d24&scoped=true"
import script from "./OptionsListTab.vue?vue&type=script&lang=js"
export * from "./OptionsListTab.vue?vue&type=script&lang=js"

import "./OptionsListTab.vue?vue&type=style&index=0&id=72ca0d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ca0d24"]])

export default __exports__